import Tooltip from '@/widgets/Tooltip.svelte';

export function tooltip(anchorNode, props = {}) {
  const {content, placement, background, color, border, boxShadow, arrowBoxShadow, hideDelay = 0, zIndex = 99999, style, offset, isFade} = props;
  let tooltipComponent = new Tooltip({
    target: document.body,
    props: {
      content,
      placement,
      anchorNode,
      background,
      color,
      border,
      boxShadow,
      arrowBoxShadow,
      hideDelay,
      zIndex,
      style,
      offset,
      isFade,
    },
  });

  let timeout;

  function show() {
    clearInterval(timeout);
    if (tooltipComponent) {
      tooltipComponent.show = true;
    }
  }

  function hide() {
    clearInterval(timeout);
    timeout = setTimeout(() => {
      if (tooltipComponent) {
        tooltipComponent.show = false;
      }
    }, hideDelay);
  }

  const showEvents = ['mouseenter', 'focus'];
  const hideEvents = ['mouseleave', 'blur'];

  showEvents.forEach((event) => anchorNode.addEventListener(event, show));
  hideEvents.forEach((event) => anchorNode.addEventListener(event, hide));

  return {
    update(props) {
      if (tooltipComponent) {
        tooltipComponent.content = props.content;
      }
    },
    destroy() {
      tooltipComponent && tooltipComponent.$destroy();
      tooltipComponent = null;
      showEvents.forEach((event) => anchorNode.removeEventListener(event, show));
      hideEvents.forEach((event) => anchorNode.removeEventListener(event, hide));
    },
  };
}
